import selfsigned from 'selfsigned';
import { getDataDirPath, ensureDataDirExists } from '@wix/cli-data-dir';
import { readFile, writeFile, stat } from 'node:fs/promises';
import path from 'node:path';

const PEM_FILENAME = 'wix-cli.pem';
const PEM_MAX_DAYS = 30;

const attrs = [
  {
    name: 'commonName',
    value: 'localhost',
  },
  {
    name: 'countryName',
    value: 'US',
  },
  {
    shortName: 'ST',
    value: 'Virginia',
  },
  {
    name: 'organizationName',
    value: 'Dev',
  },
  {
    shortName: 'OU',
    value: 'Dev',
  },
];

const generateCert = async () => {
  const generateResult = selfsigned.generate(attrs, {
    days: PEM_MAX_DAYS,
  });
  return generateResult.private + generateResult.cert;
};

const shouldRecreatePem = async (wixCliPemPath: string) => {
  const pemStat = await stat(wixCliPemPath)
    .then((stats) => stats)
    .catch(() => null);

  if (!pemStat) {
    return true;
  }

  if (
    Date.now() - pemStat.ctime.valueOf() >
    PEM_MAX_DAYS * 24 * 60 * 60 * 1000
  ) {
    return true;
  }

  return false;
};

export const generateHostCert = async () => {
  const wixDataDir = getDataDirPath();
  const wixCliPemPath = path.join(wixDataDir, PEM_FILENAME);
  const recreatePem = await shouldRecreatePem(wixCliPemPath);

  if (!recreatePem) {
    const cachedCert = await readFile(wixCliPemPath, {
      encoding: 'utf-8',
    });

    return {
      cert: cachedCert,
      key: cachedCert,
    };
  }

  const selfsignedCert = await generateCert();

  await ensureDataDirExists();
  await writeFile(wixCliPemPath, selfsignedCert, {
    encoding: 'utf-8',
  });

  return {
    cert: selfsignedCert,
    key: selfsignedCert,
  };
};
